import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { useUserContext } from "../context/UserContext";

const Navigation = ({ usrData, setTabb }) => {
    const { myPendingRequests } = useUserContext();
    const pendingCount = myPendingRequests?.length || 0;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Toggle dropdown visibility
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const navigate = useNavigate();

    // Helper function to validate image source
    const checkImageSource = (src) => {
        return src !== "https://buzzinguniverse.com/backend/" ? src : null;
    };

    const ChaNgeTab = (val) => {
        setTabb(val); setIsOpen(false);
        navigate(`/member/${usrData.id}/profile`);
    }

    const Logout = (e) => {
        e.preventDefault();
        secureLocalStorage.removeItem('auth_data');
        window.location.href = "/"
    }

    return (
        <div className="navigation text-start">
            <button className="nav-btn" onClick={toggleDropdown} style={{ position: 'relative' }}>
                <img
                    src={checkImageSource(usrData.photo) ? usrData.photo : "/images/b.png"}
                    alt="User"
                    className="user-img"
                />
                <h3 className="user-name">{usrData.fname}</h3>
                {pendingCount > 0 && (
                    <span style={{
                        position: 'absolute', top: '-6px', right: '-6px',
                        background: '#ff4444', color: '#fff', borderRadius: '50%',
                        fontSize: '11px', fontWeight: 'bold', minWidth: '18px',
                        height: '18px', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', lineHeight: 1, padding: '0 3px'
                    }}>{pendingCount}</span>
                )}
            </button>

            {isOpen && (
                <div className="navigate-dropdown" ref={dropdownRef}>
                    <ul>
                        <li onClick={() => { ChaNgeTab('activity'); }}>Profile</li>
                        <li onClick={() => { ChaNgeTab('friends'); }}>
                            Friends {pendingCount > 0 && <span style={{ background: '#ff4444', color: '#fff', borderRadius: '99px', fontSize: '11px', padding: '1px 6px', fontWeight: 'bold', marginLeft: '4px' }}>{pendingCount}</span>}
                        </li>
                        <li onClick={() => { ChaNgeTab('groups'); }}>Groups</li>
                        <li><Link to="#">Adverts</Link></li>
                        <li onClick={() => { ChaNgeTab('forums'); }}>Forums</li>
                        <li onClick={() => { ChaNgeTab('notifications'); }}>Notifications</li>
                        <li onClick={() => { ChaNgeTab('messages'); }}>Messages</li>
                        <li onClick={() => { ChaNgeTab('settings'); }}>Settings</li>
                        <li><Link to="#" onClick={Logout}>Log Out</Link></li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Navigation;
